import { Permission } from "../pages/configurations/roles/types/permissions";
import apiService from "./Api";


interface PermissionResponse {
  count: number;
  permissions: Permission[];
}

class PermissionService {
  async getAllPermissions(): Promise<Permission[]> {
    try {
      const response = await apiService.get<PermissionResponse>(
        "/api/authentication/permissions/"
      );
      return response.data.permissions || []; 
    } catch (err) {
      console.error("Failed to load permissions:", err);
      return []; 
    }
  }
}

const permissionService = new PermissionService();
export default permissionService;
